angular.module( 'acme.view.application.programs.detail.prerequisites', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.programs.detail.prerequisites.controllers',
  'acme.common.service.api',
  'acme.common.service.helpers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var programsDetailPrerequisites = {
        name: 'application.programsDetail.prerequisites',
        url: '/prerequisites',
        views: {
          "subview-main": {
            controller: 'ProgramsDetailPrerequisitesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/programs/detail/prerequisites/prerequisites.tpl.html'
          }
        },
        data: {
          pageTitle: 'Pre-requisites',
          pageClass: 'application application-programs-detail'
        },
        resolve: {
          ResolveTemplatesData: ['ApiService', 'HelpersService', function(ApiService, HelpersService) {
            return ApiService.program.list(false, HelpersService.getPaginator());
          }]
        }
      };

    $stateProvider
      .state(programsDetailPrerequisites);
});
